import {getTokenObj, loginTokenSet} from "@/mixins/Auth";
import util from "@/mixins/util";
import {LevelClass} from "@/mixins/level";


export default {
    data(){
        return{
            redirect: '/',
            LevelClass: new LevelClass(),
        }
    },
    created() {
        if (!util.isEmpty(this.$route.query.redirect)) {
            this.redirect = this.$route.query.redirect;
        }

    },
    methods:{
        checkLevel() {
            let tokenObj = getTokenObj();
            this.$api.$config.getGroup().then(res => {
                if (res.code != 1 || util.isEmpty(tokenObj.g_idx)) {
                    this.checkLevelFail();
                }else{
                    let g_idx = tokenObj.g_idx;
                    let groupList = res.result.list;
                     this.makeGroupObj(g_idx, groupList);
                }

            });
        },
         makeGroupObj(g_idx, groupList) {
            let groupIndex = groupList.findIndex(group => group.gidx === g_idx);
            if(groupIndex < 0) {
                 this.checkLevelFail();
            }else{
                let levelObj = {
                    level: groupList[groupIndex].glevel,
                    type: groupList[groupIndex].gtype,
                    isSuper: groupList[groupIndex].gisSuper === 1 ? true : false,
                }
                 this.checkLoginLevel(levelObj);
            }
        },
         checkLoginLevel(levelObj) {
             if (levelObj.type === 'normal' || levelObj.type === 'partner') {
                this.checkLevelSuccess(levelObj);
            }else{
               this.checkLevelFail("관리자는 로그인을 할 수 없습니다.");
            }
        },
         checkLevelFail(errorMsg="") {
            if(!errorMsg){
                errorMsg = "로그인에 실패하였습니다.";
            }
            this.errorMsg = errorMsg;
            this.errorAlert(errorMsg);
            loginTokenSet('');
            this.$localStorage.remove('token');
        },
        checkLevelSuccess(levelObj) {
            this.LevelClass.setterLevelObj(levelObj);
            this.$router.replace(this.redirect);
        },
    },
}
